import React from 'react';
import { createRoot } from 'react-dom/client';
import 'GlobalFunctions';
import Application from 'Application';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { StylesProvider } from '@material-ui/core/styles';

// https://material-ui.com/customization/default-theme/
const theme = createTheme({
  typography: {
    fontFamily: 'inherit'
  },
  palette: {
    primary: {
      main: '#003768',
      light: '#3F6096',
      dark: '#00113D'
    },
    secondary: {
      main: '#E91E1E',
      light: '#E5888D',
      dark: '#BB1212'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1326,
      xl: 1400
    }
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const root_node = document.getElementById('app');
  if (!root_node) return console.error('missing #app <div> on the page');
  const root = createRoot(root_node);
  root.render( /*#__PURE__*/React.createElement(StylesProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Application, null))));
});
